"use client";

import Home02Page from "@/components/marketing/home-02/HomePage";

export default function LandingPage() {
  return <Home02Page />;
}
